// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"293e96e7","669":"1c718b50"}[chunkId] + ".chunk.js";
};